import { DefaultService } from '@/services/DefaultService';

export default class RegrasDescontoItemService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(idpoliticadesconto, gupoProdutoList, situacao, sort, order,page = 0, limit = 50, ...params) {
        return this._http.post(`${this._env}/vendas/politica-comercial/regras-desconto-item.json?page=${page}&limit=${limit}&sort=${sort}&order=${order}&situacao=${situacao}&idpoliticadesconto=${idpoliticadesconto}&param=${params}`, gupoProdutoList, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateSituacao(politicadescontoItem) {
        return this._http.post(`${this._env}/vendas/politica-comercial/regras-desconto-item/updatesituacao`, politicadescontoItem, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    insertBulk(politicadescontoItem) {
        return this._http.post(`${this._env}/vendas/politica-comercial/regras-desconto-item/insertBulk`, politicadescontoItem, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}